import * as React from 'react';
import { setUserSession, checkUserSession } from './checkUserSession';

// PACKAGES
import axios from 'axios';

// UTILS
import { isObject, SITE_KEY } from '../utils';

// MODELS
import {
	AccountChangeEmailCommand,
	AccountEditPhoneNumberCommand,
	AccountLinkAccountsCommand,
	AccountLinkChildNameCommand,
	AccountLinkRequestApproveCommand,
	AccountLinkRequestRejectCommand,
	AccountLinkRequestRemoveCommand,
	AccountLinkRequestRevokeCommand,
	AccountVolunteerRequestCommand,
	AccountVolunteerRevokeCommand,
	AuthenticationResendTwoFactorTokenCommand,
	AuthenticationValidateTwoFactorCommand,
	IncidentArchiveLinkIncidentCommand,
	OrganisationPaymentInfoCommand,
	RequestsToJoinVolunteerApproveCommand,
	RequestsToJoinVolunteerDenyCommand
} from '../api/models';
import { AccountEditProfileImageCommand } from '../api/models';
import { AccountEmailChangeRequestCommand } from '../api/models';
import { AuthenticationChangePasswordCommand } from '../api/models';
import { OrganisationActivateCommand } from '../api/models';
import { OrganisationAddAdministratorCommand } from '../api/models';
import { PaymentCreateCommand } from '../api/models';
import { StaffReferenceCommand } from '../api/models';
import { OrganisationDeactivateCommand } from '../api/models';
import { OrganisationPaymentMethodCommand } from '../api/models';
import { UploadTokenCommand } from '../api/models';
import { UploadTokenAzureStorageSasResult } from '../api/models';
import { AuthenticationForgotPasswordCommand } from '../api/models';
import { AuthenticationResetPasswordCommand } from '../api/models';
import { AuthenticationLoginCommand } from '../api/models';
// import { AuthenticationLoginResponse } from '../api/models';
import { AuthenticationTokenRefreshCommand } from '../api/models';
import { AuthenticationTokenRefreshResponse } from '../api/models';
import { AuthenticationSwitchProfileCommand } from '../api/models';
import { AccountRegistrationCommand } from '../api/models';
import { AccountSendEmailVerificationCommand } from '../api/models';
import { OrganisationRegistrationCommand } from '../api/models';
import { AccountJoinOrganisationCommand } from '../api/models';
import { LeadershipTeamUnAssignCommand } from '../api/models';
import { LeadershipTeamAssignCommand } from '../api/models';
import { AccountCertificationCommand } from '../api/models';
import { IncidentArchiveAcknowledgeOnBehalfCommand } from '../api/models';
import { IncidentAcknowledgeOnBehalfCommand } from '../api/models';
import { PolicyAcknowledgeCommand } from '../api/models';
import { TrainingModuleEditCommand } from '../api/models';
import { DashboardActivityFeedCommand } from '../api/models';
import { DashboardRemoveActivityFeedCommand } from '../api/models';
import { FeedbackCreateCommand } from '../api/models';
import { FeedbackResolveCommand } from '../api/models';
import { FeedbackLogActionCommand } from '../api/models';
import { FeedbackWithdrawCommand } from '../api/models';
import { SafetyChecklistSubmitCommand } from '../api/models';
import { SafetyChecklistActionCommand } from '../api/models';
import { SafetyChecklistApproveCommand } from '../api/models';
import { SafetyChecklistAttachmentDeleteCommand } from '../api/models';
import { SafetyChecklistAttachmentUploadCommand } from '../api/models';
import { SafetyChecklistCommentCommand } from '../api/models';
import { SafetyChecklistEditCommand } from '../api/models';
import { StaffStaffTypeCommand } from '../api/models';
import { StaffDisableProfileCommand } from '../api/models';
import { VisitorsDisableProfileCommand } from '../api/models';
import { FamiliesDisableProfileCommand } from '../api/models';
import { StaffOrganisationAdminCommand } from '../api/models';
import { IncidentArchiveEditCommand } from '../api/models';
import { IncidentArchiveAcknowledgeCommand } from '../api/models';
import { IncidentAcknowledgeCommand } from '../api/models';
import { IncidentEditCommand } from '../api/models';
import { IncidentLinkIncidentCommand } from '../api/models';
import { boundProgressType } from '../components/FileUpload';
import { ChildSafeStandardDeleteCommand } from '../api/models';
import { ChildSafeStandardEditCommand } from '../api/models';
import { ChildSafeStandardReorderCommand } from '../api/models';
import { ComplaintAdviceEditCommand } from '../api/models';
import { ComplaintAdviceDeleteCommand } from '../api/models';
import { ComplaintAdviceReorderCommand } from '../api/models';
import { PolicyTemplateDeleteCommand } from '../api/models';
import { PolicyTemplateEditCommand } from '../api/models';
import { PolicyTemplateReorderCommand } from '../api/models';
import { TrainingModuleDeleteCommand } from '../api/models';
import { TrainingModuleReorderCommand } from '../api/models';
import { TrainingAdditionalTrainingEditCommand } from '../api/models';
import { TrainingEditCommand } from '../api/models';
import { TrainingMarkAsCompleteCommand } from '../api/models';
import { TrainingRemoveCommand } from '../api/models';
import { TrainingEditModuleCommand } from '../api/models';
import { TrainingDeleteModuleCommand } from '../api/models';
import { ChecklistTemplateDeleteCommand } from '../api/models';
import { ChecklistTemplateReorderCommand } from '../api/models';
import { ChecklistTemplateEditCommand } from '../api/models';
import { RequestsToJoinDenyCommand } from '../api/models';
import { RequestsToJoinApproveCommand } from '../api/models';
import { RequestsToJoinStaffTypeCommand } from '../api/models';
import { RequestsToJoinOrganisationAdminCommand } from '../api/models';
import { RequestsToJoinCiteCertificationCommand } from '../api/models';
import { PolicyArchiveCommand } from '../api/models';
import { PolicyReinstateCommand } from '../api/models';
import { PolicyEditCommand } from '../api/models';
import { ComplaintCreateCommand } from '../api/models';
import { ComplaintResolutionCommand } from '../api/models';
import { ComplaintEditActionCommand } from '../api/models';
import { ComplaintRemoveActionCommand } from '../api/models';
import { ComplaintAcceptResolutionCommand } from '../api/models';
import { ComplaintReopenCommand } from '../api/models';
import { ComplaintWithdrawCommand } from '../api/models';
import { ComplaintAddStaffCommand } from '../api/models';
import { ComplaintRemoveFamilyMemberCommand } from '../api/models';
import { OrganisationAddressCommand } from '../api/models';
import { OrganisationEditProfileImageCommand } from '../api/models';
import { OrganisationRemoveAdministratorCommand } from '../api/models/organisation-remove-administrator-command';
import { HelpDeskReorderCommand } from '../api/models';
import { HelpDeskDeleteCommand } from '../api/models';
import { HelpDeskEditCommand } from '../api/models';
import { OrganisationNumberOfChildrenCommand } from '../api/models';
import { AccountParentVerificationCommand } from '../api/models';

// API
import azureFileUpload from './azure-file-upload';
import { SafetyChecklistApi } from '../api/api';
import { TrainingApi } from '../api/api';
import { UploadApi } from '../api/api';
import { PolicyTemplateApi } from '../api/api';
import { ComplaintAdviceApi } from '../api/api';
import { ChildSafeStandardApi } from '../api/api';
import { TrainingModuleApi } from '../api/api';
import { ChecklistTemplateApi } from '../api/api';
import { GlobalApi } from '../api/api';
import { AuthenticationApi } from '../api/api';
import { AccountApi } from '../api/api';
import { OrganisationApi } from '../api/api';
import { VisitorsApi } from '../api/api';
import { NavigationApi } from '../api/api';
import { DashboardApi } from '../api/api';
import { LeadershipTeamApi } from '../api/api';
import { RequestsToJoinApi } from '../api/api';
import { FeedbackApi } from '../api/api';
import { InviteApi } from '../api/api';
import { IncidentArchiveApi } from '../api/api';
import { IncidentApi } from '../api/api';
import { StaffApi } from '../api/api';
import { FamiliesApi } from '../api/api';
import { PolicyApi } from '../api/api';
import { ComplaintApi } from '../api/api';
import { PaymentApi } from '../api/api';
import { AuditApi } from '../api/api';
import { HelpDeskApi } from '../api/api';

interface AccountEmailVerificationCommand {
	token?: string;
	email?: string;
}

interface PaymentInfoCommand {
	paymentPlanId?: string;
	numberOfChildren?: number;
}

interface RequestErrorTypes {
	isError: boolean;
	message: string;
	validationErrors: {
		name?: string;
		reason?: string;
	}[];
}

const api = () => {
	let tokenTimer: ReturnType<typeof setTimeout>;

	document.cookie = `CATimezoneOffset=${new Date().getTimezoneOffset()};max-age=${
		30 * 24 * 60 * 60
	};secure;samesite=strict;path=/`;

	const authenticationTokenRefresh = async () => {
		const fields: AuthenticationTokenRefreshCommand = {
			token: localStorage.getItem('token') || '',
			refreshToken: localStorage.getItem('refreshToken') || ''
		};

		return new AuthenticationApi().apiAuthenticationTokenrefreshPost(fields);
	};

	const destroyToken = () => {
		clearTimeout(tokenTimer);
		setUserSession(null);
		localStorage.removeItem('token');
		localStorage.removeItem('refreshToken');
		document.cookie = `AuthorizationToken=;expires=Thu, 01 Jan 1970 00:00:00 GMT;secure;samesite=strict`;
	};

	// initialisation
	// before request
	axios.interceptors.request.use(
		(config) => {
			const token = localStorage.getItem('token') || '';

			if (token) {
				config.headers = {
					...config.headers,
					Authorization: `Bearer ${token}`,
					CATimezoneOffset: new Date().getTimezoneOffset()
				};
			}

			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	// before response
	axios.interceptors.response.use(
		(response: any) => {
			// Any status code that lie within the range of 2xx cause this function to trigger

			if (response.data && response.data.result) {
				if (response.data.result.token) {
					const maxAge =
						response.data.result.cookieExpiry !== undefined ? response.data.result.cookieExpiry * 60 : 86400;
					const token = response.data.result.token;
					setUserSession(token);
					localStorage.setItem('token', token);
					document.cookie = `AuthorizationToken=${token};max-age=${maxAge};secure;samesite=strict;path=/`;

					// should output something reasonable like (30 mins - 5 mins). Or 5 mins if something goes wrong
					const tokenInterval = (maxAge - 300 > 300 ? maxAge - 300 : 300) * 1000; // seconds to milliseconds

					// setup a timeout to run again before the token expires
					clearTimeout(tokenTimer);
					tokenTimer = setTimeout(() => {
						authenticationTokenRefresh();
					}, tokenInterval);
				}

				if (response.data.result.refreshToken) {
					const refreshToken = response.data.result.refreshToken;
					localStorage.setItem('refreshToken', refreshToken);
				}
			}

			// Retry axios request 1 time if recaptcha token is bad
			if (
				response.data &&
				response.data.isError &&
				response.data.validationErrors[0].name === 'CaptchaToken' &&
				response.data.validationErrors[0].reason === 'Recaptcha token is invalid.'
			) {
				const originalRequest = response.config;

				if (!originalRequest._captchaRetry && window.grecaptcha) {
					originalRequest._captchaRetry = true;

					const params = JSON.parse(originalRequest.data);

					return new Promise((resolve) => {
						window.grecaptcha.ready(() => {
							window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then((token: string) => {
								params.captchaToken = token;
								originalRequest.data = JSON.stringify(params);
								resolve(axios(originalRequest));
							});
						});
					});
				}
			}

			return response;
		},
		(error) => {
			// Any status codes that falls outside the range of 2xx cause this function to trigger

			if (error && error.response && error.response.status === 401) {
				const originalRequest = error.config;

				if (!originalRequest._retry) {
					originalRequest._retry = true;

					return authenticationTokenRefresh()
						.then((response: any) => {
							if (response.data.isError) {
								// token refresh failed
								destroyToken();
							}
							return axios(originalRequest);
						})
						.catch((error: any) => {
							// token refresh failed
							destroyToken();
						});
				} else {
					// 2 x 401 error in a row - token refresh failed
					destroyToken();
				}
			}

			return Promise.reject(error);
		}
	);

	function request(apiCall: any) {
		// check for multiple tabs that are logged in
		checkUserSession();

		return apiCall()
			.then((response: any) => {
				return response.data;
			})
			.catch((error: any) => {
				const errorData: RequestErrorTypes = {
					isError: true,
					message: 'An error has occurred',
					validationErrors: []
				};

				if (error) {
					if (error.response && isObject(error.response.data)) {
						// Request made and server responded
						errorData.message = error.response.data.detail || errorData.message;
						if (error.response.data.validationErrors) {
							errorData.validationErrors = [...error.response.data.validationErrors];
						}
					} else if (error.request) {
						// The request was made but no response was received
						errorData.message = 'A communication error has occurred';

						// fix for cloudflare expiry on Dev and Staging
						if (window.location.host.indexOf('studiobravo') !== -1) {
							window.location.reload();
						}
					}
				}

				console.log(errorData);
				return errorData;
			});
	}

	return {
		// GLOBAL
		async getGlobalLookups() {
			return request(new GlobalApi().apiGlobalLookupsGet.bind(this));
		},

		async refreshAuthenticationToken() {
			// special case - no need to bind
			return request(authenticationTokenRefresh);
		},

		async getUploadCredentials(file: File, token: string) {
			// get azure credentials

			const fields: UploadTokenCommand = { fileName: file.name, captchaToken: token };

			return request(new UploadApi().apiUploadTokenPost.bind(this, fields));
		},

		async uploadFile(file: File, credentials: UploadTokenAzureStorageSasResult, progressCallback?: boundProgressType) {
			return await azureFileUpload(file, credentials, progressCallback);
		},

		async getMainMenu() {
			return request(new NavigationApi().apiNavigationMenuaccessrightsGet.bind(this));
		},

		async getNavigationActionTicker() {
			return request(new NavigationApi().apiNavigationActiontickerGet.bind(this));
		},

		async getUserDetails() {
			return request(new AccountApi().apiAccountUserGet.bind(this));
		},

		async doSwitchOrganisation(profileId: AuthenticationSwitchProfileCommand['profileId']) {
			const fields = { profileId };
			return request(new AuthenticationApi().apiAuthenticationSwitchprofilePost.bind(this, fields));
		},

		// REGISTER
		async doCreateAccount(fields: AccountRegistrationCommand) {
			return request(new AccountApi().apiAccountRegisterPost.bind(this, fields));
		},

		async doResendEmailVerification(fields: AccountSendEmailVerificationCommand) {
			return request(new AccountApi().apiAccountSendemailverificationPost.bind(this, fields));
		},

		async doEmailConfirmation(fields: AccountEmailVerificationCommand) {
			return request(new AccountApi().apiAccountEmailverificationPost.bind(this, fields));
		},

		async doForgotPassword(fields: AuthenticationForgotPasswordCommand) {
			return request(new AuthenticationApi().apiAuthenticationForgotpasswordPost.bind(this, fields));
		},

		async doResetPassword(fields: AuthenticationResetPasswordCommand) {
			return request(new AuthenticationApi().apiAuthenticationResetpasswordPost.bind(this, fields));
		},

		async sendParentVerification(fields: AccountParentVerificationCommand) {
			return request(new AccountApi().apiAccountParentverificationPost.bind(this, fields));
		},

		async getParentVerificationStatus(token: string, email: string, organisationIdentifier: string) {
			return request(new AccountApi().apiAccountParentverificationGet.bind(this, token, email, organisationIdentifier));
		},

		async checkAbnInUse(AustralianBusinessNumber: string, organisationId: string) {
			return request(
				new OrganisationApi().apiOrganisationAustralianbusinessnumberGet.bind(
					this,
					organisationId,
					AustralianBusinessNumber
				)
			);
		},

		async doOrganisationSearch(searchTerm: string) {
			return request(new OrganisationApi().apiOrganisationSearchGet.bind(this, searchTerm));
		},

		async getOrganisationByIdentifier(organisationIdentifier: string) {
			return request(new OrganisationApi().apiOrganisationFindGet.bind(this, organisationIdentifier));
		},

		async getOrganisationPaymentinfo(id: string) {
			return request(new OrganisationApi().apiOrganisationPaymentinfoGet.bind(this, id));
		},

		async postOrganisationPaymentInfo(fields: OrganisationPaymentInfoCommand) {
			return request(new OrganisationApi().apiOrganisationPaymentinfoPost.bind(this, fields));
		},

		async doRegisterOrganisation(fields: OrganisationRegistrationCommand) {
			return request(new OrganisationApi().apiOrganisationRegistrationPost.bind(this, fields));
		},

		async getOrganisationRegistration(id: string) {
			return request(new OrganisationApi().apiOrganisationRegistrationGet.bind(this, id));
		},

		async doRegisterOrganisationPayment(organisationId: PaymentCreateCommand['organisationId']) {
			const fields = { organisationId };
			return request(new PaymentApi().apiPaymentCreatePost.bind(this, fields));
		},

		async doJoinOrganisation(fields: AccountJoinOrganisationCommand) {
			return request(new AccountApi().apiAccountJoinorganisationPost.bind(this, fields));
		},

		async addCertification(fields: AccountCertificationCommand) {
			return request(new AccountApi().apiAccountCertificationPost.bind(this, fields));
		},

		async getAccountExistingCertifications() {
			return request(new AccountApi().apiAccountExistingcertificationsGet.bind(this));
		},

		async getRequestsTojoinReviewCertification(id?: string) {
			return request(new RequestsToJoinApi().apiRequeststojoinReviewcertificationGet.bind(this, id));
		},

		async postAccountLinkChildName(fields: AccountLinkChildNameCommand) {
			return request(new AccountApi().apiAccountLinkchildnamePost.bind(this, fields));
		},

		async postAccountLinkAccounts(fields: AccountLinkAccountsCommand) {
			return request(new AccountApi().apiAccountLinkaccountsPost.bind(this, fields));
		},

		async postAccountLinkRequestRevoke(fields: AccountLinkRequestRevokeCommand) {
			return request(new AccountApi().apiAccountLinkrequestrevokePost.bind(this, fields));
		},

		async postAccountLinkRequestRemove(fields: AccountLinkRequestRemoveCommand) {
			return request(new AccountApi().apiAccountLinkrequestremovePost.bind(this, fields));
		},

		async getAccountLinkRequest(id?: string) {
			return request(new AccountApi().apiAccountLinkrequestGet.bind(this, id));
		},

		async postAccountLinkRequestApprove(fields: AccountLinkRequestApproveCommand) {
			return request(new AccountApi().apiAccountLinkrequestapprovePost.bind(this, fields));
		},

		async postAccountLinkRequestReject(fields: AccountLinkRequestRejectCommand) {
			return request(new AccountApi().apiAccountLinkrequestrejectPost.bind(this, fields));
		},

		// LOGIN
		async doLogin(fields: AuthenticationLoginCommand) {
			destroyToken();

			return request(new AuthenticationApi().apiAuthenticationLoginPost.bind(this, fields));
		},

		async postAuthenticationValidateTwoFactor(fields: AuthenticationValidateTwoFactorCommand) {
			return request(new AuthenticationApi().apiAuthenticationValidatetwofactorPost.bind(this, fields));
		},

		async postAuthenticationResendTwoFactorToken(fields: AuthenticationResendTwoFactorTokenCommand) {
			return request(new AuthenticationApi().apiAuthenticationResendtwofactortokenPost.bind(this, fields));
		},

		async doLogout() {
			destroyToken();
		},

		// PLANS
		async getPlanTypes() {
			return request(new PaymentApi().apiPaymentPlansGet.bind(this));
		},

		// DASHBOARD
		async getDashboardItems() {
			return request(new DashboardApi().apiDashboardSectionsummariesGet.bind(this));
		},

		async postAccountWalkthroughComplete() {
			return request(new AccountApi().apiAccountWalkthroughcompletePost.bind(this));
		},

		// ACTIVITY FEED
		async getActivityFeed() {
			return request(new DashboardApi().apiDashboardActivityfeedGet.bind(this));
		},

		async updateActivityFeed(fields: DashboardActivityFeedCommand) {
			return request(new DashboardApi().apiDashboardActivityfeedPost.bind(this, fields));
		},

		async deleteFeedItem(fields: DashboardRemoveActivityFeedCommand) {
			return request(new DashboardApi().apiDashboardRemoveactivityfeedPost.bind(this, fields));
		},

		// MY ACCOUNT
		async getAccountMyAccount() {
			return request(new AccountApi().apiAccountMyaccountGet.bind(this));
		},

		async postAccountEmailChangeRequest(fields: AccountEmailChangeRequestCommand) {
			return request(new AccountApi().apiAccountEmailchangerequestPost.bind(this, fields));
		},

		async postAccountChangeEmail(fields: AccountChangeEmailCommand) {
			return request(new AccountApi().apiAccountChangeemailPost.bind(this, fields));
		},

		async postAccountEditProfileImage(fields: AccountEditProfileImageCommand) {
			return request(new AccountApi().apiAccountEditprofileimagePost.bind(this, fields));
		},

		async getAccountCertification(id?: string) {
			return request(new AccountApi().apiAccountCertificationGet.bind(this, id));
		},

		async postAuthenticationChangePassword(fields: AuthenticationChangePasswordCommand) {
			return request(new AuthenticationApi().apiAuthenticationChangepasswordPost.bind(this, fields));
		},
		async postAccountEditPhoneNumber(fields: AccountEditPhoneNumberCommand) {
			return request(new AccountApi().apiAccountEditphonenumberPost.bind(this, fields));
		},

		async postAccountVolunteerRemove(fields: AccountVolunteerRevokeCommand) {
			return request(new AccountApi().apiAccountVolunteerremovePost.bind(this, fields));
		},

		async postAccountVolunteerRequest(fields: AccountVolunteerRequestCommand) {
			return request(new AccountApi().apiAccountVolunteerrequestPost.bind(this, fields));
		},

		async postAccountVolunteerRevoke(fields: AccountVolunteerRevokeCommand) {
			return request(new AccountApi().apiAccountVolunteerrevokePost.bind(this, fields));
		},

		// STAFF
		async getStaffData() {
			return request(new StaffApi().apiStaffDashboardGet.bind(this));
		},

		async getStaffProfileData(id: string) {
			return request(new StaffApi().apiStaffFetchGet.bind(this, id));
		},

		async assignStaffOrganisationRole(fields: StaffStaffTypeCommand) {
			return request(new StaffApi().apiStaffStafftypePost.bind(this, fields));
		},

		async disableStaff(fields: StaffDisableProfileCommand) {
			return request(new StaffApi().apiStaffDisableprofilePost.bind(this, fields));
		},

		async assignOrganisationAdminStatus(fields: StaffOrganisationAdminCommand) {
			return request(new StaffApi().apiStaffOrganisationadminPost.bind(this, fields));
		},

		async postStaffReference(fields: StaffReferenceCommand) {
			return request(new StaffApi().apiStaffReferencePost.bind(this, fields));
		},

		async getStaffReference(id?: string) {
			return request(new StaffApi().apiStaffReferenceGet.bind(this, id));
		},

		// LEADERSHIP
		async getLeadershipTeamData() {
			return request(new LeadershipTeamApi().apiLeadershipteamMembersGet.bind(this));
		},

		async removeLeadershipTeamMember(fields: LeadershipTeamUnAssignCommand) {
			return request(new LeadershipTeamApi().apiLeadershipteamUnassignPost.bind(this, fields));
		},

		async searchLeadershipTeamMember(searchTerm: string) {
			return request(new LeadershipTeamApi().apiLeadershipteamSearchGet.bind(this, searchTerm));
		},

		async addLeadershipTeamMember(fields: LeadershipTeamAssignCommand) {
			return request(new LeadershipTeamApi().apiLeadershipteamAssignPost.bind(this, fields));
		},

		// FAMILIES
		async getFamiliesData() {
			return request(new FamiliesApi().apiFamiliesDashboardGet.bind(this));
		},

		async getFamiliesProfileData(id?: string) {
			return request(new FamiliesApi().apiFamiliesFetchGet.bind(this, id));
		},

		async disableFamilyMember(fields: FamiliesDisableProfileCommand) {
			return request(new FamiliesApi().apiFamiliesDisableprofilePost.bind(this, fields));
		},

		// VISITORS
		async getVisitorsData() {
			return request(new VisitorsApi().apiVisitorsDashboardGet.bind(this));
		},

		async getVisitorsProfileData(id?: string) {
			return request(new VisitorsApi().apiVisitorsFetchGet.bind(this, id));
		},

		async disableVisitor(fields: VisitorsDisableProfileCommand) {
			return request(new VisitorsApi().apiVisitorsDisableprofilePost.bind(this, fields));
		},

		// REQUESTS TO JOIN
		async getRequestsToJoinData() {
			return request(new RequestsToJoinApi().apiRequeststojoinPendingrequestsGet.bind(this));
		},

		async getRequestsToJoinDetailData(profileId: string) {
			return request(new RequestsToJoinApi().apiRequeststojoinFetchGet.bind(this, profileId));
		},

		async assignRequestsToJoinOrganisationRole(fields: RequestsToJoinStaffTypeCommand) {
			return request(new RequestsToJoinApi().apiRequeststojoinStafftypePost.bind(this, fields));
		},

		async assignRequestsToJoinOrganisationAdminStatus(fields: RequestsToJoinOrganisationAdminCommand) {
			return request(new RequestsToJoinApi().apiRequeststojoinOrganisationadminPost.bind(this, fields));
		},

		async approveRequestsToJoin(fields: RequestsToJoinApproveCommand) {
			return request(new RequestsToJoinApi().apiRequeststojoinApprovePost.bind(this, fields));
		},

		async denyRequestsToJoin(fields: RequestsToJoinDenyCommand) {
			return request(new RequestsToJoinApi().apiRequeststojoinDenyPost.bind(this, fields));
		},

		async confirmDocumentsCited(fields: RequestsToJoinCiteCertificationCommand) {
			return request(new RequestsToJoinApi().apiRequeststojoinCitecertificationPost.bind(this, fields));
		},

		async getCertificationDetail(id: string) {
			return request(new RequestsToJoinApi().apiRequeststojoinReviewcertificationGet.bind(this, id));
		},

		async postRequestsToJoinVolunteerApprove(fields: RequestsToJoinVolunteerApproveCommand) {
			return request(new RequestsToJoinApi().apiRequeststojoinVolunteerapprovePost.bind(this, fields));
		},

		async postRequestsToJoinVolunteerDeny(fields: RequestsToJoinVolunteerDenyCommand) {
			return request(new RequestsToJoinApi().apiRequeststojoinVolunteerdenyPost.bind(this, fields));
		},

		// INVITE TO JOIN
		async getInviteToJoinsData() {
			return request(new InviteApi().apiInviteInvitelinksGet.bind(this));
		},

		// CHILD SAFE STANDARDS SUPER ADMIN
		async getChildSafeStandardDashboard() {
			return request(new ChildSafeStandardApi().apiChildsafestandardAdmindashboardGet.bind(this));
		},

		async getChildSafeStandardEdit(id?: string) {
			return request(new ChildSafeStandardApi().apiChildsafestandardEditGet.bind(this, id));
		},

		async postChildSafeStandardEdit(fields: ChildSafeStandardEditCommand) {
			return request(new ChildSafeStandardApi().apiChildsafestandardEditPost.bind(this, fields));
		},

		async postChildSafeStandardDelete(fields: ChildSafeStandardDeleteCommand) {
			return request(new ChildSafeStandardApi().apiChildsafestandardDeletePost.bind(this, fields));
		},

		async postChildSafeStandardReorder(fields: ChildSafeStandardReorderCommand) {
			return request(new ChildSafeStandardApi().apiChildsafestandardReorderPost.bind(this, fields));
		},

		// CHILD SAFE STANDARDS
		async getChildSafeStandardsData() {
			return request(new ChildSafeStandardApi().apiChildsafestandardUserdashboardGet.bind(this));
		},

		async getChildSafeStandardsDetailData(id?: string) {
			return request(new ChildSafeStandardApi().apiChildsafestandardFetchGet.bind(this, id));
		},

		// POLICIES SUPER ADMIN
		async getPolicyTemplateAsset(id?: string) {
			return request(new PolicyTemplateApi().apiPolicytemplateAssetGet.bind(this, id));
		},

		async getPolicyTemplateDashboard() {
			return request(new PolicyTemplateApi().apiPolicytemplateDashboardGet.bind(this));
		},

		async getPolicyTemplateEdit(id?: string) {
			return request(new PolicyTemplateApi().apiPolicytemplateEditGet.bind(this, id));
		},

		async postPolicyTemplateEdit(fields: PolicyTemplateEditCommand) {
			return request(new PolicyTemplateApi().apiPolicytemplateEditPost.bind(this, fields));
		},

		async postPolicyTemplateDelete(fields: PolicyTemplateDeleteCommand) {
			return request(new PolicyTemplateApi().apiPolicytemplateDeletePost.bind(this, fields));
		},

		async postPolicyTemplateReorder(fields: PolicyTemplateReorderCommand) {
			return request(new PolicyTemplateApi().apiPolicytemplateReorderPost.bind(this, fields));
		},

		// POLICIES
		async getPoliciesAdminData() {
			return request(new PolicyApi().apiPolicyAdmindashboardGet.bind(this));
		},

		async getPoliciesUserData() {
			return request(new PolicyApi().apiPolicyUserdashboardGet.bind(this));
		},

		async getPoliciesDetailsData(id: string) {
			return request(new PolicyApi().apiPolicyEditGet.bind(this, id));
		},

		async submitPolicy(fields: PolicyEditCommand) {
			return request(new PolicyApi().apiPolicyEditPost.bind(this, fields));
		},

		async getPolicyTemplatesData() {
			return request(new PolicyApi().apiPolicyPolicytemplatesGet.bind(this));
		},

		async archivePolicy(fields: PolicyArchiveCommand) {
			return request(new PolicyApi().apiPolicyArchivePost.bind(this, fields));
		},

		async reInstatePolicy(fields: PolicyReinstateCommand) {
			return request(new PolicyApi().apiPolicyReinstatePost.bind(this, fields));
		},

		async acceptPolicy(fields: PolicyAcknowledgeCommand) {
			return request(new PolicyApi().apiPolicyAcknowledgePost.bind(this, fields));
		},

		// TRAINING
		async getTrainingAdminDashboard() {
			return request(new TrainingApi().apiTrainingAdmindashboardGet.bind(this));
		},

		async postTrainingEdit(fields: TrainingEditCommand) {
			return request(new TrainingApi().apiTrainingEditPost.bind(this, fields));
		},

		async getTrainingView(id?: string) {
			return request(new TrainingApi().apiTrainingViewGet.bind(this, id));
		},

		async postTrainingRemove(fields: TrainingRemoveCommand) {
			return request(new TrainingApi().apiTrainingRemovePost.bind(this, fields));
		},

		async getTrainingUserDashboard() {
			return request(new TrainingApi().apiTrainingUserdashboardGet.bind(this));
		},

		async getAdditionalTrainingDetail(id?: string) {
			return request(new TrainingApi().apiTrainingAdditionaltrainingeditGet.bind(this, id));
		},

		async postTrainingAdditionalTrainingEdit(fields: TrainingAdditionalTrainingEditCommand) {
			return request(new TrainingApi().apiTrainingAdditionaltrainingeditPost.bind(this, fields));
		},

		async postTrainingMarkAsComplete(fields: TrainingMarkAsCompleteCommand) {
			return request(new TrainingApi().apiTrainingMarkascompletePost.bind(this, fields));
		},

		async submitOrganisationNewTrainingModule(fields: TrainingEditModuleCommand) {
			return request(new TrainingApi().apiTrainingEditmodulePost.bind(this, fields));
		},

		async getOrganisationNewTrainingModule(id?: string) {
			return request(new TrainingApi().apiTrainingEditmoduleGet.bind(this, id));
		},

		async deleteOrganisationNewTrainingModule(fields: TrainingDeleteModuleCommand) {
			return request(new TrainingApi().apiTrainingDeletemodulePost.bind(this, fields));
		},

		// SAFETY CHECKLIST
		async getSafetyChecklistAsset(id?: string) {
			return request(new SafetyChecklistApi().apiSafetychecklistAssetGet.bind(this, id));
		},

		async getSafetyChecklistsTemplates() {
			return request(new SafetyChecklistApi().apiSafetychecklistTemplatesGet.bind(this));
		},

		async getSafetyChecklistTemplate(templateId?: string, checklistId?: string) {
			return request(new SafetyChecklistApi().apiSafetychecklistTemplateGet.bind(this, templateId, checklistId));
		},

		async getAdminSafetyChecklistDashboard() {
			return request(new SafetyChecklistApi().apiSafetychecklistAdmindashboardGet.bind(this));
		},

		async getUserSafetyChecklistDashboard() {
			return request(new SafetyChecklistApi().apiSafetychecklistUserdashboardGet.bind(this));
		},

		async getSafetyChecklistEdit(checklistId?: string, templateId?: string, checklistTemplateId?: string) {
			return request(
				new SafetyChecklistApi().apiSafetychecklistEditGet.bind(this, checklistId, templateId, checklistTemplateId)
			);
		},

		async postSafetyChecklistEdit(fields: SafetyChecklistEditCommand) {
			return request(new SafetyChecklistApi().apiSafetychecklistEditPost.bind(this, fields));
		},

		async getSafetyChecklistChecklist(id?: string) {
			return request(new SafetyChecklistApi().apiSafetychecklistChecklistGet.bind(this, id));
		},

		async getSafetyChecklistComment(id?: string) {
			return request(new SafetyChecklistApi().apiSafetychecklistCommentGet.bind(this, id));
		},

		async postSafetyChecklistComment(fields: SafetyChecklistCommentCommand) {
			return request(new SafetyChecklistApi().apiSafetychecklistCommentPost.bind(this, fields));
		},

		async getSafetyChecklistAttachments(id?: string) {
			return request(new SafetyChecklistApi().apiSafetychecklistAttachmentsGet.bind(this, id));
		},

		async postSafetyChecklistAttachmentUpload(fields: SafetyChecklistAttachmentUploadCommand) {
			return request(new SafetyChecklistApi().apiSafetychecklistAttachmentuploadPost.bind(this, fields));
		},

		async postSafetyChecklistAttachmentDelete(fields: SafetyChecklistAttachmentDeleteCommand) {
			return request(new SafetyChecklistApi().apiSafetychecklistAttachmentdeletePost.bind(this, fields));
		},

		async postSafetyChecklistSubmit(fields: SafetyChecklistSubmitCommand) {
			return request(new SafetyChecklistApi().apiSafetychecklistSubmitPost.bind(this, fields));
		},

		async postSafetyChecklistApprove(fields: SafetyChecklistApproveCommand) {
			return request(new SafetyChecklistApi().apiSafetychecklistApprovePost.bind(this, fields));
		},

		async getSafetyChecklistApprovers() {
			return request(new SafetyChecklistApi().apiSafetychecklistApproversGet.bind(this));
		},

		async postSafetyChecklistAction(fields: SafetyChecklistActionCommand) {
			return request(new SafetyChecklistApi().apiSafetychecklistActionPost.bind(this, fields));
		},

		async getSafetyChecklistSummaryPdf(id?: string) {
			return request(new SafetyChecklistApi().apiSafetychecklistSummarypdfassetGet.bind(this, id));
		},

		// SUPER ADMIN CHECKLISTS
		async getChecklistTemplateDashboard() {
			return request(new ChecklistTemplateApi().apiChecklisttemplateDashboardGet.bind(this));
		},

		async postChecklistTemplateEdit(fields: ChecklistTemplateEditCommand) {
			return request(new ChecklistTemplateApi().apiChecklisttemplateEditPost.bind(this, fields));
		},

		async getChecklistTemplateEdit(id?: string) {
			return request(new ChecklistTemplateApi().apiChecklisttemplateEditGet.bind(this, id));
		},

		async postChecklistTemplateDelete(fields: ChecklistTemplateDeleteCommand) {
			return request(new ChecklistTemplateApi().apiChecklisttemplateDeletePost.bind(this, fields));
		},

		async postChecklistTemplateReorder(fields: ChecklistTemplateReorderCommand) {
			return request(new ChecklistTemplateApi().apiChecklisttemplateReorderPost.bind(this, fields));
		},

		// FEEDBACK
		async getAdminFeedbackData() {
			return request(new FeedbackApi().apiFeedbackAdmindashboardGet.bind(this));
		},

		async getUserFeedbackData() {
			return request(new FeedbackApi().apiFeedbackUserdashboardGet.bind(this));
		},

		async getFeedbackDetailsData(id: string) {
			return request(new FeedbackApi().apiFeedbackFetchGet.bind(this, id));
		},

		async getFeedbackProgress(id: string) {
			return request(new FeedbackApi().apiFeedbackActionsGet.bind(this, id));
		},

		async logFeedbackProgress(fields: FeedbackLogActionCommand) {
			return request(new FeedbackApi().apiFeedbackLogactionPost.bind(this, fields));
		},

		async createFeedback(fields: FeedbackCreateCommand) {
			return request(new FeedbackApi().apiFeedbackCreatePost.bind(this, fields));
		},

		async resolveFeedback(fields: FeedbackResolveCommand) {
			return request(new FeedbackApi().apiFeedbackResolvePost.bind(this, fields));
		},

		async withdrawFeedback(fields: FeedbackWithdrawCommand) {
			return request(new FeedbackApi().apiFeedbackWithdrawPost.bind(this, fields));
		},

		// INCIDENT REPORT
		async getAdminIncidentReportsData() {
			return request(new IncidentApi().apiIncidentAdmindashboardGet.bind(this));
		},

		async getUserIncidentReportsData() {
			return request(new IncidentApi().apiIncidentUserdashboardGet.bind(this));
		},

		async getIncidentReportsDetailsDataArchive(id: string) {
			return request(new IncidentArchiveApi().apiIncidentarchiveEditGet.bind(this, id));
		},

		async getIncidentReportsDetailsData(id: string) {
			return request(new IncidentApi().apiIncidentEditGet.bind(this, id));
		},

		async acknowledgeYourselfArchive(fields: IncidentArchiveAcknowledgeCommand) {
			return request(new IncidentArchiveApi().apiIncidentarchiveAcknowledgePost.bind(this, fields));
		},

		async acknowledgeYourself(fields: IncidentAcknowledgeCommand) {
			return request(new IncidentApi().apiIncidentAcknowledgePost.bind(this, fields));
		},

		async getAcceptModalDetailArchive(id?: string) {
			return request(new IncidentArchiveApi().apiIncidentarchiveAcknowledgeonbehalfGet.bind(this, id));
		},

		async getAcceptModalDetail(id?: string) {
			return request(new IncidentApi().apiIncidentAcknowledgeonbehalfGet.bind(this, id));
		},

		async acceptAcknowledgementArchive(fields: IncidentArchiveAcknowledgeOnBehalfCommand) {
			return request(new IncidentArchiveApi().apiIncidentarchiveAcknowledgeonbehalfPost.bind(this, fields));
		},

		async acceptAcknowledgement(fields: IncidentAcknowledgeOnBehalfCommand) {
			return request(new IncidentApi().apiIncidentAcknowledgeonbehalfPost.bind(this, fields));
		},

		async searchOthersRecipientsArchive(searchTerm: string) {
			return request(new IncidentArchiveApi().apiIncidentarchiveRecipientsGet.bind(this, searchTerm));
		},

		async searchOthersRecipients(searchTerm: string) {
			return request(new IncidentApi().apiIncidentRecipientsGet.bind(this, searchTerm));
		},

		// Archive Incident Report Submit
		async createIncidentReport(fields: IncidentArchiveEditCommand) {
			return request(new IncidentArchiveApi().apiIncidentarchiveEditPost.bind(this, fields));
		},

		// Incident Report Submit
		async submitIncidentReport(fields: IncidentEditCommand) {
			return request(new IncidentApi().apiIncidentEditPost.bind(this, fields));
		},

		// Archive Incident Report
		async loadIncidentReportArchive(id?: string) {
			return request(new IncidentArchiveApi().apiIncidentarchiveEditGet.bind(this, id));
		},

		async loadIncidentReport(id?: string) {
			return request(new IncidentApi().apiIncidentEditGet.bind(this, id));
		},

		// Archive Link Request
		async getIncidentLinkRequestArchive(recipientId?: string) {
			return request(new IncidentArchiveApi().apiIncidentarchiveLinkrequestGet.bind(this, recipientId));
		},

		async getIncidentLinkRequest(recipientId?: string) {
			return request(new IncidentApi().apiIncidentLinkrequestGet.bind(this, recipientId));
		},

		async postIncidentLinkIncidentArchive(fields: IncidentArchiveLinkIncidentCommand) {
			return request(new IncidentArchiveApi().apiIncidentarchiveLinkincidentPost.bind(this, fields));
		},

		async postIncidentLinkIncident(fields: IncidentLinkIncidentCommand) {
			return request(new IncidentApi().apiIncidentLinkincidentPost.bind(this, fields));
		},

		// COMPLAINTS SUPER ADMIN
		async getComplaintAdviceDashboard() {
			return request(new ComplaintAdviceApi().apiComplaintadviceDashboardGet.bind(this));
		},

		async getComplaintAdviceEdit(id?: string) {
			return request(new ComplaintAdviceApi().apiComplaintadviceEditGet.bind(this, id));
		},

		async postComplaintAdviceEdit(fields: ComplaintAdviceEditCommand) {
			return request(new ComplaintAdviceApi().apiComplaintadviceEditPost.bind(this, fields));
		},

		async postComplaintAdviceDelete(fields: ComplaintAdviceDeleteCommand) {
			return request(new ComplaintAdviceApi().apiComplaintadviceDeletePost.bind(this, fields));
		},

		async postComplaintAdviceReorder(fields: ComplaintAdviceReorderCommand) {
			return request(new ComplaintAdviceApi().apiComplaintadviceReorderPost.bind(this, fields));
		},

		async getComplaintAdviceAsset(id?: string) {
			return request(new ComplaintAdviceApi().apiComplaintadviceAssetGet.bind(this, id));
		},

		// COMPLAINTS
		async getAdminComplaintsData() {
			return request(new ComplaintApi().apiComplaintAdmindashboardGet.bind(this));
		},

		async getUserComplaintsData() {
			return request(new ComplaintApi().apiComplaintUserdashboardGet.bind(this));
		},

		async getComplaintsNotifiedMembersList() {
			return request(new ComplaintApi().apiComplaintMembercandidatesGet.bind(this));
		},

		async submitComplaint(fields: ComplaintCreateCommand) {
			return request(new ComplaintApi().apiComplaintCreatePost.bind(this, fields));
		},

		async getComplaintsDetailsData(id: string) {
			return request(new ComplaintApi().apiComplaintFetchGet.bind(this, id));
		},

		async resolveComplaint(fields: ComplaintResolutionCommand) {
			return request(new ComplaintApi().apiComplaintResolutionPost.bind(this, fields));
		},

		async getComplaintResolution(id?: string) {
			return request(new ComplaintApi().apiComplaintResolutionGet.bind(this, id));
		},

		async getComplaintsAdviceData() {
			return request(new ComplaintApi().apiComplaintComplaintadviceGet.bind(this));
		},

		async getComplaintsProgress(id?: string) {
			return request(new ComplaintApi().apiComplaintActionsGet.bind(this, id));
		},

		async logComplaintsProgress(fields: ComplaintEditActionCommand) {
			return request(new ComplaintApi().apiComplaintEditactionPost.bind(this, fields));
		},

		async removeComplaintsProgress(fields: ComplaintRemoveActionCommand) {
			return request(new ComplaintApi().apiComplaintRemoveactionPost.bind(this, fields));
		},

		async getResolutionReviewDetail(id?: string) {
			return request(new ComplaintApi().apiComplaintAcceptresolutionGet.bind(this, id));
		},

		async acceptResolution(fields: ComplaintAcceptResolutionCommand) {
			return request(new ComplaintApi().apiComplaintAcceptresolutionPost.bind(this, fields));
		},

		async reOpenComplaint(fields: ComplaintReopenCommand) {
			return request(new ComplaintApi().apiComplaintReopenPost.bind(this, fields));
		},

		async withdrawComplaint(fields: ComplaintWithdrawCommand) {
			return request(new ComplaintApi().apiComplaintWithdrawPost.bind(this, fields));
		},

		async searchComplaintResolveStaffMember(id: string, searchTerm: string) {
			return request(new ComplaintApi().apiComplaintStaffcandidatesGet.bind(this, id, searchTerm));
		},

		async addComplaintResolveStaffMember(fields: ComplaintAddStaffCommand) {
			return request(new ComplaintApi().apiComplaintAddstaffPost.bind(this, fields));
		},

		async removeFamilyMember(fields: ComplaintRemoveFamilyMemberCommand) {
			return request(new ComplaintApi().apiComplaintRemovefamilymemberPost.bind(this, fields));
		},

		// AUDITS
		async getAuditId() {
			return request(new AuditApi().apiAuditGeneratePost.bind(this));
		},

		async getAuditReport(id: string) {
			return request(new AuditApi().apiAuditReadyGet.bind(this, id));
		},

		async cancelPlan() {
			return request(new OrganisationApi().apiOrganisationCancelplanPost.bind(this));
		},

		// SETTING
		async getOrganisationDetail() {
			return request(new OrganisationApi().apiOrganisationSettingsGet.bind(this));
		},

		async getOrganisationAddress() {
			return request(new OrganisationApi().apiOrganisationAddressGet.bind(this));
		},

		async submitOrganisationAddress(fields: OrganisationAddressCommand) {
			return request(new OrganisationApi().apiOrganisationAddressPost.bind(this, fields));
		},

		async submitOrganisationLogo(fields: OrganisationEditProfileImageCommand) {
			return request(new OrganisationApi().apiOrganisationEditprofileimagePost.bind(this, fields));
		},

		async getPaymentUpdateLink() {
			return request(new PaymentApi().apiPaymentCustomerPost.bind(this));
		},

		async updateNumberOfChildren(fields: OrganisationNumberOfChildrenCommand) {
			return request(new OrganisationApi().apiOrganisationNumberofchildrenPost.bind(this, fields));
		},

		// HELP DESK
		async getHelpDeskData() {
			return request(new HelpDeskApi().apiHelpdeskUserdashboardGet.bind(this));
		},

		async getHelpDeskDetailData(id?: string) {
			return request(new HelpDeskApi().apiHelpdeskFetchGet.bind(this, id));
		},

		// HELP DESK SUPER ADMIN
		async getHelpDeskAdminDashboard() {
			return request(new HelpDeskApi().apiHelpdeskAdmindashboardGet.bind(this));
		},

		async getHelpDeskAdminDetailData(id?: string) {
			return request(new HelpDeskApi().apiHelpdeskEditGet.bind(this, id));
		},

		async postHelpDeskEdit(fields: HelpDeskEditCommand) {
			return request(new HelpDeskApi().apiHelpdeskEditPost.bind(this, fields));
		},

		async postHelpDeskDelete(fields: HelpDeskDeleteCommand) {
			return request(new HelpDeskApi().apiHelpdeskDeletePost.bind(this, fields));
		},

		async postHelpDeskReorder(fields: HelpDeskReorderCommand) {
			return request(new HelpDeskApi().apiHelpdeskReorderPost.bind(this, fields));
		},

		// COMPANIES
		async getCompaniesData() {
			return request(new OrganisationApi().apiOrganisationListGet.bind(this));
		},

		async getCompaniesDetailData(id?: string) {
			return request(new OrganisationApi().apiOrganisationDetailsGet.bind(this, id));
		},

		async postOrganisationDeactivate(fields: OrganisationDeactivateCommand) {
			return request(new OrganisationApi().apiOrganisationDeactivatePost.bind(this, fields));
		},

		async postOrganisationActivate(fields: OrganisationActivateCommand) {
			return request(new OrganisationApi().apiOrganisationActivatePost.bind(this, fields));
		},

		async getOrganisationAdminCandidates(organisationId?: string, searchTerm?: string) {
			return request(
				new OrganisationApi().apiOrganisationAdministratorcandidatesGet.bind(this, organisationId, searchTerm)
			);
		},

		async getOrganisationAdministrators(organisationId?: string) {
			return request(new OrganisationApi().apiOrganisationAdministratorsGet.bind(this, organisationId));
		},

		async postOrganisationAddAdmin(fields: OrganisationAddAdministratorCommand) {
			return request(new OrganisationApi().apiOrganisationAddadministratorPost.bind(this, fields));
		},

		async postOrganisationRemoveAdmin(fields: OrganisationRemoveAdministratorCommand) {
			return request(new OrganisationApi().apiOrganisationRemoveadministratorPost.bind(this, fields));
		},

		// SUPER ADMIN TRAINING MODULES
		async getTrainingModuleDashboard() {
			return request(new TrainingModuleApi().apiTrainingmoduleDashboardGet.bind(this));
		},

		async getTrainingModuleEdit(id?: string) {
			return request(new TrainingModuleApi().apiTrainingmoduleEditGet.bind(this, id));
		},

		async postTrainingModuleEdit(fields: TrainingModuleEditCommand) {
			return request(new TrainingModuleApi().apiTrainingmoduleEditPost.bind(this, fields));
		},

		async postTrainingModuleReorder(fields: TrainingModuleReorderCommand) {
			return request(new TrainingModuleApi().apiTrainingmoduleReorderPost.bind(this, fields));
		},

		async postTrainingModuleDelete(fields: TrainingModuleDeleteCommand) {
			return request(new TrainingModuleApi().apiTrainingmoduleDeletePost.bind(this, fields));
		}
	};
};

export default api();
